<template>
    <v-container>
        <v-row>
            <v-col cols="10">
                <v-text-field
                    v-model="result.search"
                    label="Búsqueda"
                ></v-text-field>
            </v-col>
            <v-col cols="2">
                <v-menu
                    :location="location"
                    :close-on-content-click="false"
                    nudge-bottom="35"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark v-bind="attrs" v-on="on">
                            <v-icon>mdi-filter</v-icon>
                        </v-btn>
                    </template>

                    <v-list style="min-width: 20rem">
                        <v-list-item
                            v-for="(item, index) in headers"
                            :key="index"
                        >
                            <div
                                style="
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                    padding-top: 0.25rem;
                                "
                            >
                                <div
                                    @click="activarItem(item)"
                                    style="
                                        display: flex;
                                        cursor: pointer;
                                        justify-content: space-between;
                                        flex-direction: row;
                                        width: 100%;
                                    "
                                >
                                    <div>{{ item.title }}</div>
                                    <div style="flex: 1"></div>
                                    <svg
                                        :class="`icon ${
                                            item.active ? 'upside-down' : ''
                                        }`"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke-width="1.5"
                                        stroke="currentColor"
                                        style="width: 1rem; height: 1rem"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                                        />
                                    </svg>
                                </div>

                                <div
                                    :class="`menu ${
                                        item.active ? 'active' : ''
                                    }`"
                                    v-if="item.item != null"
                                >
                                    <div v-if="item.type == 'date'">
                                        <v-select
                                            :value="item.item.tipo"
                                            @input="
                                                (val) => {
                                                    updateTipo(item.item, val);
                                                }
                                            "
                                            label="Tipo"
                                            :items="opciones_fecha"
                                        ></v-select>
                                        <date-select
                                            v-model="result[item.model].start"
                                            v-if="item.item.tipo != 2"
                                            label="Desde"
                                        >
                                        </date-select>
                                        <date-select
                                            v-model="result[item.model].end"
                                            v-if="item.item.tipo != 1"
                                            label="Hasta"
                                        >
                                        </date-select>
                                    </div>
                                    <div v-else-if="item.type == 'select'">
                                        <v-select
                                            v-model="result[item.model].value"
                                            label="Seleccione uno"
                                            @input="changeRes(item)"
                                            :items="item.items"
                                            :item-text="item.item_text"
                                            :item-value="item.item_value"
                                        ></v-select>
                                    </div>
                                    <div v-else-if="item.type == 'check'">
                                        <v-checkbox
                                            v-model="result[item.model].value"
                                            label="Seleccionar"
                                            :value="true"
                                        ></v-checkbox>
                                    </div>
                                    <div v-else-if="item.type == 'cliente'">
                                        <cliente-select-vue
                                            :label="
                                                item.multiple
                                                    ? 'Clientes'
                                                    : 'Cliente'
                                            "
                                            :multiple="!!item.multiple"
                                            dense
                                            v-model="result[item.model].value"
                                        ></cliente-select-vue>
                                    </div>
                                    <div v-else-if="item.type == 'presupuesto'">
                                        <presupuesto-select-vue
                                            label="Presupuesto"
                                            v-model="result[item.model].value"
                                        ></presupuesto-select-vue>
                                    </div>
                                    <div v-else-if="item.type == 'ordenes'">
                                        <ordenes-select-vue
                                            :label="
                                                item.multiple ? 'Obras' : 'Obra'
                                            "
                                            :multiple="!!item.multiple"
                                            :id-cliente="clientesFiltroActivo"
                                            dense
                                            v-model="result[item.model].value"
                                        ></ordenes-select-vue>
                                    </div>
                                    <div v-else-if="item.type == 'proveedor'">
                                        <proveedores-select-vue
                                            label="Proveedor"
                                            v-model="result[item.model].value"
                                        ></proveedores-select-vue>
                                    </div>
                                    <div v-else-if="item.type == 'albaran'">
                                        <albaranes-select-vue
                                            label="Albarán"
                                            v-model="result[item.model].value"
                                        ></albaranes-select-vue>
                                    </div>
                                    <div
                                        v-else-if="item.type == 'albaran_venta'"
                                    >
                                        <albaran-venta-select-vue
                                            label="Albarán de venta"
                                            v-model="result[item.model].value"
                                        ></albaran-venta-select-vue>
                                    </div>
                                    <div v-else-if="item.type == 'number'">
                                        <v-text-field
                                            v-model="result[item.model].value"
                                            type="number"
                                            :label="item.label || 'Importe'"
                                            :suffix="item.suffix"
                                        ></v-text-field>
                                    </div>
                                    <div v-else>
                                        <v-text-field
                                            v-model="result[item.model].value"
                                            :item-text="
                                                item.item_text == null
                                                    ? 'nombre'
                                                    : item.item_text
                                            "
                                            :item-value="
                                                item.item_value == null
                                                    ? 'id'
                                                    : item.item_value
                                            "
                                            label="Búsqueda"
                                        ></v-text-field>
                                    </div>
                                </div>
                            </div>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <v-col cols="12">
                <div style="width: 100%; display: flex; flex-wrap: wrap">
                    <template v-for="key in Object.keys(result)">
                        <template v-if="result[key]">
                            <v-chip
                                style="margin-bottom: 0.25rem"
                                v-if="tieneValorFiltro(key)"
                            >
                                <div style="display: flex; align-items: center">
                                    <div style="padding-right: 1rem">
                                        {{ getChipData(key) }}
                                    </div>
                                    <div
                                        style="
                                            cursor: pointer;
                                            display: flex;
                                            align-items: center;
                                        "
                                        @click="deleteItem(key)"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke-width="2"
                                            stroke="currentColor"
                                            class="icon"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </v-chip>
                        </template>
                    </template>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style>
.menu {
    overflow: hidden;
    max-height: 0px;
    transition: max-height 0.3s;
}

.menu.active {
    display: block;
    max-height: 320px;
    overflow-y: auto;
}
.icon {
    width: 1rem;
    height: 1rem;
    transition: transform 0.3s;
}

.icon.upside-down {
    transform: rotate(180deg);
}
</style>
<script>
import albaranesSelectVue from "./albaranesSelect.vue";
import albaranVentaSelectVue from "./albaranVentaSelect.vue";
import clienteSelectVue from "./clienteSelect.vue";
import ordenesSelectVue from "./ordenesSelect.vue";
import PresupuestoSelectVue from "./PresupuestoSelect.vue";
import proveedoresSelectVue from "./proveedoresSelect.vue";
export default {
    props: ["value", "headers"],
    components: {
        clienteSelectVue,
        PresupuestoSelectVue,
        ordenesSelectVue,
        albaranesSelectVue,
        proveedoresSelectVue,
        albaranVentaSelectVue,
    },
    created() {
        this.result = this.value ?? {};
        this.checkItems();
    },
    data() {
        return {
            dialog: false,
            result: {},
            opciones_fecha: [
                { value: 1, text: "Desde" },
                { value: 2, text: "Hasta" },
                { value: 3, text: "Entre" },
            ],

            locations: ["top", "bottom", "start", "end", "center"],
            location: "top",
        };
    },
    watch: {
        value: {
            deep: true,
            handler(val) {
                this.result = val ?? {};
                this.checkItems();
            },
        },
        result: {
            deep: true,
            handler(val) {
                this.$emit("input", val);
            },
        },
        clientesFiltroActivo: {
            deep: true,
            handler() {
                // Al cambiar clientes, limpiar obras si el filtro de obras es múltiple
                const obrasKey = this.headers.find(
                    (h) => h.type === "ordenes" && h.multiple
                )?.model;
                if (
                    obrasKey &&
                    this.result[obrasKey] &&
                    Array.isArray(this.result[obrasKey].value)
                ) {
                    // La limpieza fina la hace ordenesSelect; aquí no forzamos vacío
                }
            },
        },
    },
    computed: {
        clientesFiltroActivo() {
            const clienteHeader = this.headers.find(
                (h) => h.type === "cliente"
            );
            if (!clienteHeader) return null;
            const val = this.result[clienteHeader.model]?.value;
            if (Array.isArray(val)) {
                return val.filter((id) => id != null && id !== "");
            }
            return val != null && val !== "" ? val : null;
        },
    },
    methods: {
        tieneValorFiltro(key) {
            if (key === "search" || !this.result[key]) return false;
            const item = this.result[key];
            if (Array.isArray(item.value)) {
                return item.value.length > 0;
            }
            return (
                (item.value != "" && item.value != null) ||
                (item.nombre != "" && item.nombre != null) ||
                (item.start != "" && item.start != null) ||
                (item.end != "" && item.end != null)
            );
        },
        changeRes(item) {
            const selected = item.items.find((element) => {
                return (
                    element[item.item_value ?? "value"] ==
                    this.result[item.model].value
                );
            });

            if (selected) {
                this.result[item.model].nombre = selected[item.item_text];
            } else {
                this.result[item.model].nombre = "Sin Asignar";
            }
        },

        getChipData(key) {
            const header = this.headers.find((h) => h.model === key);
            const titulo = header?.title || key;
            let result = `${titulo}: `;
            if (Array.isArray(this.result[key].value)) {
                result += `${this.result[key].value.length} seleccionado(s)`;
            } else if (this.result[key].nombre != null && this.result[key].nombre !== "") {
                result += this.result[key].nombre;
            } else if (
                this.result[key].start != null ||
                this.result[key].end != null
            ) {
                result += `${this.result[key].start || ""}${
                    this.result[key].start != null &&
                    this.result[key].end != null
                        ? " - "
                        : ""
                }${this.result[key].end || ""}`;
            } else {
                result += this.result[key].value;
            }

            return result;
        },
        deleteItem(key) {
            const header = this.headers.find((h) => h.model === key);
            if (header?.multiple) {
                this.result[key].value = [];
            } else {
                this.result[key].value = "";
            }
            this.result[key].start = "";
            this.result[key].end = "";
            this.result[key].nombre = "";
        },
        updateTipo(model, value) {
            model.tipo = value;
            const resultado = JSON.stringify(this.result);
            this.result = [];
            this.result = JSON.parse(resultado);
        },
        checkItems() {
            let changed = false;
            this.headers.forEach((element) => {
                if (this.result[element.model ?? element.title] == null) {
                    this.result[element.model ?? element.title] = { tipo: 1 };
                    changed = true;
                    if (element.type == "date") {
                        this.result[element.model ?? element.title].end = "";
                        this.result[element.model ?? element.title].start = "";
                    } else if (element.multiple) {
                        this.result[element.model ?? element.title].value =
                            element.default_value != null
                                ? element.default_value
                                : [];
                    } else {
                        if (element.default_value != null) {
                            this.result[element.model ?? element.title].value =
                                element.default_value;
                        } else {
                            this.result[element.model ?? element.title].value =
                                "";
                        }
                    }
                }
                element.item = this.result[element.model ?? element.title];
            });
            if (changed) this.result = JSON.parse(JSON.stringify(this.result));
        },
        activarItem(_item) {
            this.headers.forEach((item) => {
                if (item == _item) {
                    item.active = !item.active;
                } else {
                    item.active = false;
                }
            });
        },
    },
};
</script>
